// 人员需求管理


import { hrClient } from "@/api/index";
import { dialerServiceClient } from "@/api/dialerServiceClient";
import { SaveArchiveReq,Archive,ArchivePersonal,ArchiveIdentity,ArchiveWork,ArchiveFamily,ArchiveOccupancys,
    ArchiveRewards,ArchiveOffice,ArchiveAttachments,ArchiveContact,ArchiveOccupancy,ArchiveReward,ArchiveAttachment,GetArchiveReq,GetOfficeListReq,DownloadDocumentReq} from "@/pbjs/xcommon/log_pb";

import {  UploadDocumentReq } from "@/pbjs/xcommon/collection_pb";  // 提交还款问题上报

import { MediaV2Req} from "@/pbjs/xcommon/dialer_pb";
import { Page } from "@/utils/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import InnerRequest from "./request";

export interface Options {
    Archive: any;
    ArchiveID: number;
    UserID:number;
    Page: Page;
    ArchivePersonal: {
        name : string,
        gender : number,
        birthday : number,
        mobile : string,
        email : string,
        panelstatus : number 
    };
    ArchiveIdentity: {
        identity :string,
        rfc:string,
        curp:string,
        identityphoto :string,
        panelstatus:number,
    };
    ArchiveWork: {
        employeeid:string,
        role:string,
        panelstatus:number
    };
    ArchiveFamily: {
        maritalstatus:number,
        childrennumber:number,
        familyaddress:string,
        familyaddrphoto: string,
        contactList:[{
            id:number,
            contact:string,
            relationship:number,
            panelstatus:number
        }],
        panelstatus:number
    };
    ArchiveOccupancys: {
        panelstatus:number,
        listList:[{
            id:number,
            company:string,
            position:string,
            begintime:number,
            endtime:number,
            panelstatus:number
            
        }],
    };
    ArchiveRewards: {
        listList:[{
            id:number,
            rewardtype:number,
            rewardcategory:number,
            rewarditem:number,
            amount:number,
            remark:string,
            panelstatus:number
        }],
        panelstatus:number
    };
    ArchiveAttachments: {
        listList:[{
            id:number,
            attachmentname:string,
            attachmentid:number,
            panelstatus:number
        }],
        panelstatus:number

    };
    
    ArchiveOffice: {
        id:number,
        officestatus:number,
        officetime:number,
        reason:string,
        // panelstatus:number
    };
    UpdateTime: number,
    resourceid:string,
    usermark:number,
    // setCommonin:any
}
interface IMediaOptions {
    VOIPRecordID: number;
}

export function getSaveArchiveReq(arg: Options) {
    let requestPerson = new ArchivePersonal();
    requestPerson.setName(arg.ArchivePersonal.name)
    requestPerson.setGender(arg.ArchivePersonal.gender)
    requestPerson.setBirthday(arg.ArchivePersonal.birthday)
    requestPerson.setMobile(arg.ArchivePersonal.mobile)
    requestPerson.setEmail(arg.ArchivePersonal.email)
    requestPerson.setPanelstatus(arg.ArchivePersonal.panelstatus)

    let requestIdentity = new ArchiveIdentity();
    requestIdentity.setIdentity(arg.ArchiveIdentity.identity)
    requestIdentity.setRfc(arg.ArchiveIdentity.rfc)
    requestIdentity.setCurp(arg.ArchiveIdentity.curp)
    requestIdentity.setIdentityphoto(arg.ArchiveIdentity.identityphoto)
    requestIdentity.setPanelstatus(arg.ArchiveIdentity.panelstatus)

    let requestWork = new ArchiveWork();
    requestWork.setEmployeeid(arg.ArchiveWork.employeeid)
    requestWork.setRole(arg.ArchiveWork.role)
    requestWork.setPanelstatus(arg.ArchiveWork.panelstatus)

    let requestFamily = new ArchiveFamily();
    requestFamily.setMaritalstatus(arg.ArchiveFamily.maritalstatus)
    requestFamily.setChildrennumber(arg.ArchiveFamily.childrennumber)
    requestFamily.setFamilyaddress(arg.ArchiveFamily.familyaddress)
    requestFamily.setFamilyaddrphoto(arg.ArchiveFamily.familyaddrphoto)
    let _arr: any[] = [];

    arg.ArchiveFamily.contactList.forEach((item: any) => {
        let requestContact = new ArchiveContact()
        requestContact.setId(item.id)
        requestContact.setContact(item.contact)
        requestContact.setRelationship(item.relationship)
        requestContact.setPanelstatus(item.panelstatus)
        _arr.push(requestContact)
    })
    requestFamily.setContactList(_arr)
    requestFamily.setPanelstatus(arg.ArchiveFamily.panelstatus)


    let requestOccupancys = new ArchiveOccupancys();
    let _arrTwo: any[] = [];
    arg.ArchiveOccupancys.listList.forEach((item: any) => {
        let requestOccupancy = new ArchiveOccupancy()
        requestOccupancy.setId(item.id)
        requestOccupancy.setCompany(item.company)
        requestOccupancy.setPosition(item.position)
        requestOccupancy.setBegintime(item.begintime)
        requestOccupancy.setEndtime(item.endtime)
        requestOccupancy.setPanelstatus(item.panelstatus)
        _arrTwo.push(requestOccupancy)
    })
    requestOccupancys.setListList(_arrTwo)
    requestOccupancys.setPanelstatus(arg.ArchiveOccupancys.panelstatus)

    let requestRewards = new ArchiveRewards();
    let _arrThree: any[] = [];
    arg.ArchiveRewards.listList.forEach((item: any) => {
        let requestReward = new ArchiveReward()
        requestReward.setId(item.id)
        requestReward.setRewardtype(item.rewardtype)
        requestReward.setRewardcategory(item.rewardcategory)
        requestReward.setRewarditem(item.rewarditem)
        requestReward.setAmount(item.amount)
        requestReward.setRemark(item.remark)
        requestReward.setPanelstatus(item.panelstatus)
        _arrThree.push(requestReward)

    })
    requestRewards.setListList(_arrThree)
    requestRewards.setPanelstatus(arg.ArchiveRewards.panelstatus)

    let requestOffice = new ArchiveOffice();
    if(arg.ArchiveOffice.officetime > 0  && arg.ArchiveOffice.officestatus > 0 && arg.ArchiveOffice.id >= 0){
        requestOffice.setId(arg.ArchiveOffice.id)
        requestOffice.setOfficestatus(arg.ArchiveOffice.officestatus)
        requestOffice.setOfficetime(arg.ArchiveOffice.officetime)
        requestOffice.setReason(arg.ArchiveOffice.reason)
    }


    let requestAttachments = new ArchiveAttachments();
    let requestAttachment = new ArchiveAttachment()
    let _arrFour: any[] = [];
    arg.ArchiveAttachments.listList.forEach((item: any) => {
        requestAttachment.setId(item.id)
        requestAttachment.setAttachmentname(item.attachmentname)
        requestAttachment.setAttachmentid(item.attachmentid)
        requestAttachment.setPanelstatus(item.panelstatus)
        _arrFour.push(requestAttachment)
    })
    requestAttachments.setListList(_arrFour)
    requestAttachments.setPanelstatus(arg.ArchiveAttachments.panelstatus)

    let requestArchive = new Archive()
    requestArchive.setUpdatetime(arg.UpdateTime)
    requestArchive.setArchiveid(arg.ArchiveID)
    requestArchive.setPersonal(requestPerson)
    requestArchive.setIdentity(requestIdentity)
    requestArchive.setWork(requestWork)
    requestArchive.setFamily(requestFamily)
    requestArchive.setOccupancy(requestOccupancys)
    requestArchive.setReward(requestRewards)
    requestArchive.setAttachment(requestAttachments)
    requestArchive.setUserid(arg.UserID)
    if(arg.ArchiveOffice.officetime > 0  && arg.ArchiveOffice.officestatus > 0 && arg.ArchiveOffice.id >= 0){
        requestArchive.setOffice(requestOffice)
    }
    let request: any = new SaveArchiveReq();
    request.setArchive(requestArchive);
    return request;
}
// 
export const getSaveArchiveRequest = new InnerRequest(
    hrClient,
    hrClient.createArchive,
);

export const updateArchiveRequest = new InnerRequest(
    hrClient,
    hrClient.updateArchive,
);

export const deleteArchivePanelRequest = new InnerRequest(
    hrClient,
    hrClient.deleteArchivePanel
);

// 获取档案信息
export function getArchiveReq(arg:Options){
    let request = new GetArchiveReq();
    request.setArchiveid(arg.ArchiveID)
    request.setUserid(arg.UserID)
    return request
}

// 获取档案信息
export const getArchiveRequest = new InnerRequest(
    hrClient,
    hrClient.getArchive
);

//stream  方法
export function downloadDocumentReq(arg: Options) {
    return new Promise((resolve, reject) => {
         (async () => {
            let request: any = new DownloadDocumentReq();
            request.setCommonin(setCommon());
            request.setResourceid(arg.resourceid);
            request.setUsemark(arg.usermark);
            // return request
            var stream =hrClient.downloadDocument(request,{});
            stream.on('data',function (response:any) {
                 const res: any = response.toObject();
                resolve(res);
            })
             stream.on("err", function(err:any) {
                 reject(err);
             });
        })();
    }).then((response: any) => {
            response.loading = false;
            handleResponse(response, null);
            return response;
        })
        .catch((err: any) => {

            errorMsg(err);
        });
}
// 个人档案入离职记录
export const downloadDocumentRequest = new InnerRequest(
    hrClient,
    hrClient.downloadDocument
);

//个人档案入离职记录
export function getOfficeListReq(arg:Options){

    let request = new GetOfficeListReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize))
    request.setUserid(arg.UserID)
    request.setArchiveid(arg.ArchiveID)
    return request
}
// 个人档案入离职记录
export const getOfficeListRequest = new InnerRequest(
    hrClient,
    hrClient.getOfficeList
);

export interface uploadOptions {
    Relatedid:string,
    ContentType:string,
    Exten:string,
    Data:string
}

//个人档案入离职记录
export function uploadDocumentReq(arg:uploadOptions){
    let request = new UploadDocumentReq();
    request.setRelatedid(arg.Relatedid)
    request.setContenttype(arg.ContentType)
    request.setExten(arg.Exten)
    request.setData(arg.Data)

    return request

}

export const uploadDocumentRequest = new InnerRequest(
    hrClient,
    hrClient.uploadDocument
);

